
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {IBook} from "@/interfaces/book.interface";
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
  import {bus} from '@/plugins/bus';
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import SelectParks from "@/components/SpecialFilters/SelectParks.vue";
  import {IApp} from "@/interfaces/app.interface";

  @Component({
    components: {SelectParks}
  })
  export default class TopControls extends Vue {
    @Prop() description: string;
    @Prop() sortingSwitched: boolean;
    @Prop() userInfo: { email: string; phone: string; };

    parkId = null;

    get selectedPark(): IBook.ParkBookItem { return this.parksBook.find(park => park.id === this.parkId); }
    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }
    get parksBook(): IBook.ParkBookItem[] { return this.$store.getters['book/parksBook']; }

    get computedParkId() { return this.parkId; }
    set computedParkId(value) {
      this.parkId = value;
      localStorage.setItem(Barrier.LocalStorageKeys.SelectedPark, JSON.stringify(this.parkId));
      this.$emit('getBarriers', this.parkId);
    }

    async created() {
      const storageValue = localStorage.getItem(Barrier.LocalStorageKeys.SelectedPark);
      this.parkId = this.parksBook.length === 1
        ? this.parksBook[0].id
        : storageValue && JSON.parse(storageValue) !== 0
          ? JSON.parse(storageValue)
          :  null;

      this.$emit('getBarriers', this.parkId);
    }

    openPayScreen() {
      this.$store.dispatch('openPage', {routeName: IApp.ROUTE_NAME.PAGE_SCREEN_PAY});
    }

    toggleSorting() {
      this.$emit('toggleSorting');
    }

    destroyed() {
      bus.$off('numberInputFocus');
    }
  }
